import Modules from '@app/modules';
Modules.register({
    namespace: 'RF/Reference',
    blocks: {
    // Reference: () => import('@app/modules/WP/Reference/Blocks/Reference.vue'),
    }
});
